import type { App, Ref } from 'vue'
import { watch } from 'vue'
import type { Router } from 'vue-router'
import type { Maybe } from '@/types'
import type { CustomerProduct } from '@/types/customer/products'

export const ymId = import.meta.env.VITE_YANDEX_METRIKA_ID
export const clientId = getClientId()

export function initMetrika(app: App, router: Router) {
  router.isReady().then(() => {
    console.log('Yandex.Metrika initialized:', ymId, '/', clientId)

    app.config.globalProperties.goal = goal

    selectActionByRouteName(router.currentRoute.value.name as string)

    watch(router.currentRoute, () => {
      selectActionByRouteName(router.currentRoute.value.name as string)
    })
  })
}

function selectActionByRouteName(routeName: string) {
  console.debug('Route name:', routeName)
  goal(routeName)
}

export function goal(name: string, price: Maybe<number> = null) {
  if (window.ym) {
    if (!price) {
      window.ym(ymId, 'reachGoal', name)
    } else {
      window.ym(ymId, 'reachGoal', name, {
        order_price: price.toString(2),
        currency: 'RUB',
      })
    }
  }
}

export function goalBuy1Click(orderCode: string, product: CustomerProduct) {
  goal('order_1click')

  if (window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            id: orderCode,
          },
          products: [
            {
              id: product.value.code,
              name: product.value.name,
              price: product.value.price,
              brand: product.value.brand,
              category: product.value.category,
              variant: product.value.size,
              quantity: 1,
            },
          ],
        },
      },
    })
  }
}

export function goalViewProduct(
  product: Ref<CustomerProduct>,
  discountedPrice: Ref<Maybe<number>>
) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        detail: {
          products: [
            {
              id: product.value.code,
              name: product.value.name,
              price: discountedPrice.value,
              brand: product.value.brand,
              category: product.value.category,
              variant: product.value.size,
              quantity: 1,
            },
          ],
        },
      },
    })
  }
}

export function goalAddProductToCart(
  product: CustomerProduct,
  discountedPrice: Ref<Maybe<number>>
) {
  if (window.dataLayer) {
    window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        add: {
          products: [
            {
              id: product.value.code,
              name: product.value.name,
              price: discountedPrice.value,
              brand: product.value.brand,
              category: product.value.category,
              variant: product.value.size,
              quantity: 1,
            },
          ],
        },
      },
    })
  }
}

export function goalBuy(orderCode: Maybe<string>, products: CustomerProduct[]) {
  if (window.dataLayer) {
    // console.log(products)
    const productList = products.value.map((item) => {
      return {
        id: item.id,
        name: item.name,
        price: item.price,
        brand: item.brand,
        category: item.category,
        variant: item.size,
        quantity: item.amount,
      }
    })
    // console.log(productList)
    window.dataLayer.push({
      ecommerce: {
        currencyCode: 'RUB',
        purchase: {
          actionField: {
            id: orderCode ?? 'example',
          },
          products: productList,
        },
      },
    })
  }
}

export function getClientId(): string | null {
  const match = document.cookie.match('(?:^|;)\\s*_ym_uid=([^;]*)')
  return match ? decodeURIComponent(match[1]) : null
}
